module.exports = __webpack_public_path__ + "static/media/PR.d4624813.svg";